"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _wujiComp = _interopRequireDefault(require("./wujiComp"));
var _logger = _interopRequireDefault(require("./utils/logger"));
var wujiComp = new _wujiComp["default"]();
if (!window) {
  _logger["default"].error('%c wujiComp must run in a browser environment!', 'color: red;');
  // eslint-disable-next-line no-underscore-dangle
} else if (window.wujiComp && !window.wujiComp.__preload) {
  // 如果含有__preload说明是预下载的wujiComp 可以正常替换
  _logger["default"].error('%c wujicomp already exists in window, please check!', 'color: red;');
} else {
  window.wujiComp = wujiComp;
}
var _default = exports["default"] = wujiComp;